import type { ReactNode } from 'react';
import { Spinner } from './Spinner';

interface StatCardProps {
  label: string;
  value: ReactNode;
  /** Dong phu duoi con so: doi chieu, don vi, hoac ly do "khong ap dung". */
  hint?: ReactNode;
  loading?: boolean;
  /**
   * The bi vo hieu (vi du "tien tiet kiem" khi upstream dang TAT).
   * Hien mo di va noi ro ly do — KHONG bao gio hien so 0 gia.
   */
  unavailable?: boolean;
  unavailableText?: string;
}

export function StatCard({
  label,
  value,
  hint,
  loading = false,
  unavailable = false,
  unavailableText = 'không áp dụng',
}: StatCardProps) {
  return (
    <div className="cf-card p-4">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400">
        {label}
      </p>
      <div className="mt-2 min-h-[2.25rem]">
        {loading ? (
          <Spinner size={20} />
        ) : unavailable ? (
          <p className="text-2xl font-semibold text-slate-400 dark:text-slate-600">
            {unavailableText}
          </p>
        ) : (
          <p className="text-2xl font-semibold text-slate-900 dark:text-slate-50">{value}</p>
        )}
      </div>
      {hint !== undefined && (
        <div className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">{hint}</div>
      )}
    </div>
  );
}
